import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Checkbox = ({ label, name, checked, onChange, className, disabled, onlyCheckbox }) => {
  if (onlyCheckbox) {
    return (
      <input
        type="checkbox"
        name={name}
        className={className}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    );
  }

  return (
    <Fragment>
      <label
        className={classnames('flex items-center text-sm mb-5', className, {
          'opacity-50': disabled,
        })}
      >
        <input
          type="checkbox"
          name={name}
          className="mr-4"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />{' '}
        {label}
      </label>
    </Fragment>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  onlyCheckbox: PropTypes.bool,
};

Checkbox.defaultProps = {
  label: '',
  className: '',
  checked: false,
  onlyCheckbox: false,
  onChange: () => null,
};

export default Checkbox;
